import React from 'react';
import { useTranslation } from 'react-i18next';
import './VideoTuneInput.scss';
import { Option } from '../../../common/interfaces';
import { Dropdown } from '../../FormComponents/Dropdown/Dropdown';
import { VideoTuneEnum } from '../../../types/enums/VideoTuneEnum';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const VideoTuneInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const options: Option[] = [];

  for (const key in VideoTuneEnum) {
    if (isNaN(Number(key))) {
      options.push({
        text: `${key}`,
        value: `${VideoTuneEnum[key as keyof typeof VideoTuneEnum]}`,
      });
    }
  }

  const onChange = (option: Option) => {
    if (project.encoder) {
      if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
        updateStream({
          transcoderVideoTune: parseInt(option.value),
        });
      } else {
        updateEncoder(project.encoder, {
          transcoderVideoTune: parseInt(option.value),
        });
      }
    }
  };

  return (
    <div className="video-tune-input">
      <div className="input-title">
        {t('producer.inputs.video-tune.title')}
        <Help
          title="Video Tune"
          text="<b>Film:</b> Optimized for natural film content, preserving smooth motion and color fidelity.<br/><br/><b>Animation:</b> Designed for animated content, improving clarity in large flat areas and sharp edges.<br/><br/><b>Grain:</b> Maintains fine details and film grain in the video.<br/><br/><b>Still Image:</b> Optimized for static images or slideshows, minimizing unnecessary compression artifacts.<br/><br/><b>Peak Signal-to-Noise Ratio (PSNR):</b> Focuses on maximizing signal quality for objective visual fidelity.<br/><br/><b>Structural Similarity Index Measure (SSIM):</b> Optimizes encoding to preserve perceived visual quality based on human visual perception.<br/><br/><b>Fast Decode:</b> Prioritizes decoding speed, making playback smoother on devices with limited processing power.<br/><br/><b>Zero Latency:</b> Minimizes latency for live streaming, ideal for real-time applications."
        />
      </div>
      <Dropdown
        value={project.encoder.transcoderVideoTune.toString()}
        options={options}
        onChange={onChange}
        placeholderKey="producer.inputs.video-tune.placeholder"
        readonly={false}
      />
      <div className="input-component-footer">{t('producer.inputs.video-tune.footer')}</div>
    </div>
  );
};

export default React.memo(VideoTuneInput);
